"use client";
import React from "react";
import { PieChart, Pie, Sector, ResponsiveContainer, Cell, Legend } from "recharts";
import { useTheme } from "../../Theme/Theme";
import { PieSectorDataItem } from "recharts/types/polar/Pie";

const renderActiveShape = (props: PieSectorDataItem) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g
      style={{
        overflow: "visible",
      }}
    >
      {/* <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text> */}
      <Sector cx={cx} cy={cy} innerRadius={innerRadius} outerRadius={outerRadius} startAngle={startAngle} endAngle={endAngle} fill={fill} />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${value}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

export interface WcPieChartProps {
  noDataTitle: string;
  data: {
    name: string;
    value: number;
    color: string;
  }[];
  innerRadius: number;
  outerRadius: number;
  width: number | string;
  height: number | string;
  cx: string;
  cy: string;
}

export const WcPieChart = (props: WcPieChartProps) => {
  const theme = useTheme();
  const [activeIndex, setActiveIndex] = React.useState(0);

  const { data } = props;

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const filteredZeroValues = data.filter((d) => d.value !== 0);
  const noData = filteredZeroValues.length === 0;

  const noDataElements = [
    {
      name: props.noDataTitle || "No data",
      value: 1,
      color: theme.palette.action.disabled,
    },
  ];

  return (
    <ResponsiveContainer
      width={props.width}
      height={props.height}
      style={{
        overflow: "visible",
      }}
    >
      <PieChart
        style={{
          overflow: "visible",
        }}
      >
        {noData && (
          <Pie
            data={noDataElements}
            cx={props.cx}
            cy={props.cy}
            display="flex"
            innerRadius={props.innerRadius}
            outerRadius={props.outerRadius}
            fill={theme.palette.secondary.main}
            dataKey="value"
            paddingAngle={5}
            onMouseEnter={onPieEnter}
            // activeShape={renderActiveShape}
          >
            {noDataElements.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        )}
        {!noData && (
          <Pie
            style={{
              overflow: "visible",
            }}
            activeShape={renderActiveShape}
            data={filteredZeroValues}
            cx={props.cx}
            cy={props.cy}
            innerRadius={props.innerRadius}
            outerRadius={props.outerRadius}
            fill={theme.palette.primary.main}
            dataKey="value"
            paddingAngle={5}
            onMouseEnter={onPieEnter}
          >
            {filteredZeroValues.map((entry, index) => (
              <Cell
                style={{
                  overflow: "visible",
                }}
                key={`cell-${index}`}
                fill={entry.color}
              />
            ))}
          </Pie>
        )}
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
